import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

var _this = this;

import React, { useEffect, useState, useReducer } from "react";
import { useHistory } from "react-router-dom";
import { connect, ReactReduxContext } from "react-redux";
import { CATALOGUETYPES } from "../../constants";
import { Container, Row, Col } from "react-bootstrap";
import { AuthenticationState } from "react-aad-msal";
import Heading from "../heading/Heading";
import ImageLoader from "../images/ImageLoader";
import { FaChevronLeft } from "react-icons/fa";
import { capitalizeObjEntries, mobileAppUtil } from "../../util"; // Redux

import { accountDuck } from "../../ducks/account";
import ReturnsModalForm from "../retail/returns/ReturnsModalForm";
import * as UTIL from "../../util";
import { Loading } from "../state";
import moment from "moment";
import MediaQuery from "react-responsive";
import PegModule from "../loyalty/PegModule";
import { Image, RichText, Text } from "@sitecore-jss/sitecore-jss-react";
import { Button } from "react-bootstrap";
var accountOperations = accountDuck.operations;

var AccountOrders = function AccountOrders(props) {
  var _props$getAccountOrde = props.getAccountOrders,
      getAccountOrders = _props$getAccountOrde === void 0 ? function () {
    return console.log("Get account orders");
  } : _props$getAccountOrde,
      isGuest = props.isGuest,
      _props$responseGuestO = props.responseGuestOrder,
      responseGuestOrder = _props$responseGuestO === void 0 ? function () {
    return "";
  } : _props$responseGuestO,
      _props$toReturn = props.toReturn,
      toReturn = _props$toReturn === void 0 ? function () {
    return "";
  } : _props$toReturn,
      _props$setShowReplace = props.setShowReplacement,
      setShowReplacement = _props$setShowReplace === void 0 ? function () {
    return "";
  } : _props$setShowReplace,
      _props$showReplacemen = props.showReplacement,
      showReplacement = _props$showReplacemen === void 0 ? function () {
    return "";
  } : _props$showReplacemen,
      token = props.token,
      _props$reOrderItems = props.reOrderItems,
      reOrderItems = _props$reOrderItems === void 0 ? function () {
    return console.log("Order Again");
  } : _props$reOrderItems,
      _props$addLineFromOrd = props.addLineFromOrder,
      addLineFromOrder = _props$addLineFromOrd === void 0 ? function () {
    return console.log("Order Again for one line item");
  } : _props$addLineFromOrd,
      _props$setReOrderSucc = props.setReOrderSuccess,
      setReOrderSuccess = _props$setReOrderSucc === void 0 ? function () {
    return "";
  } : _props$setReOrderSucc,
      reOrderSuccess = props.reOrderSuccess,
      mockOrders = props.mockOrders;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      orders = _useState2[0],
      setOrders = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoading = _useState4[0],
      setIsLoading = _useState4[1];

  var _useState5 = useState({}),
      _useState6 = _slicedToArray(_useState5, 2),
      fields = _useState6[0],
      setFields = _useState6[1];

  var layout = {
    background: "solid",
    padding: "medium"
  };
  var title = "My Orders";
  var history = useHistory();

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      currentOrder = _useState8[0],
      setCurrentOrder = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      showOrderDetails = _useState10[0],
      setShowOrderDetails = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      OrderAgainActionclicked = _useState12[0],
      setOrderAgainAction = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      showMissCreditInfo = _useState14[0],
      setShowMissCreditInfo = _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      clickedBack = _useState16[0],
      setClickedBack = _useState16[1];

  useEffect(function () {
    if (mockOrders && mockOrders === "true") {
      getAccountOrders().then(function (response) {
        setOrders(response.data.orders);
        setFields(response.data.fields);
        setIsLoading(false);
      });
    } else {
      var _isLoading = props.isLoading,
          _orders = props.orders,
          _fields = props.fields;

      if (_isLoading) {
        setIsLoading(_isLoading);
      } else if (_orders) {
        setIsLoading(false);

        if (_orders.length >= 0) {
          setOrders(_orders);
        }
      }

      if (_fields) {
        setFields(_fields);
      }
    }
  }, [props.orders, props.isLoading, mockOrders]);
  useEffect(function () {
    if (!isGuest && !showOrderDetails && (token === null || token === void 0 ? void 0 : token.jwtIdToken)) {
      getAccountOrders();
      setReOrderSuccess(false);
    }
  }, [token === null || token === void 0 ? void 0 : token.jwtIdToken, showOrderDetails]);
  useEffect(function () {
    if (Array.isArray(orders) && orders.length === 1 && !clickedBack) {
      console.log("orders", orders);
      setCurrentOrder(orders[0]);
      setShowOrderDetails(true);
    }
  }, [orders]);
  useEffect(function () {
    if (!isGuest && reOrderSuccess && OrderAgainActionclicked) {
      history.push("/cart");
    }
  }, [reOrderSuccess, OrderAgainActionclicked]);
  if (UTIL.mobileAppUtil.isMobileApp()) return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ReturnsModalForm, {
    store: props === null || props === void 0 ? void 0 : props.store,
    show: showReplacement,
    hide: function hide() {
      return setShowReplacement(false);
    }
  }), !showOrderDetails || !showMissCreditInfo ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Heading, {
    level: "2",
    field: {
      value: title
    },
    className: "cb-account__title"
  }), !isLoading && orders.length ? orders.map(function (item, index) {
    var Item = capitalizeObjEntries(item);
    return /*#__PURE__*/React.createElement(OrderCard, {
      key: "order-".concat(index),
      item: Item,
      viewDetailsActionCopy: "View Details",
      viewDetailsAction: function viewDetailsAction(e) {
        setReOrderSuccess(false);
        setCurrentOrder(Item);
        setShowOrderDetails(true);
        setClickedBack(false);
      },
      orderAgainActionCopy: "Order Again",
      orderAgainAction: function orderAgainAction(e) {
        reOrderItems(Item === null || Item === void 0 ? void 0 : Item.OrderNumber);
        setOrderAgainAction(true);
      }
    });
  }) : /*#__PURE__*/React.createElement("div", null, !isLoading && /*#__PURE__*/React.createElement("p", null, "You don't have any past orders."), isLoading && /*#__PURE__*/React.createElement(Loading, {
    isLoading: true
  }))) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "cb-account-card__nav-container"
  }, !isGuest && !showMissCreditInfo && /*#__PURE__*/React.createElement("a", {
    href: "#",
    className: "cb-account-card__back",
    onClick: function onClick(e) {
      e.preventDefault();
      setShowOrderDetails(false);
      setClickedBack(true);
    }
  }, /*#__PURE__*/React.createElement(FaChevronLeft, null)), isGuest && !showMissCreditInfo && /*#__PURE__*/React.createElement("a", {
    href: "#",
    className: "cb-account-card__back",
    onClick: function onClick(e) {
      e.preventDefault();
      responseGuestOrder();
    }
  }, "Find Different Order"), !showMissCreditInfo && /*#__PURE__*/React.createElement("span", {
    className: "cb-account-card__nav-header"
  }, "Order Details")), !showMissCreditInfo && showOrderDetails ? /*#__PURE__*/React.createElement(CurrentOrder, _extends({
    order: currentOrder,
    isGuest: isGuest,
    returnAction: function returnAction(item) {
      setShowReplacement(true);
      toReturn(item);
    },
    topAction: function topAction(orderId, lineId) {
      addLineFromOrder(orderId, lineId);
      setOrderAgainAction(true);
    },
    fields: fields
  }, props)) : /*#__PURE__*/React.createElement(MissingCredit, _extends({}, props, {
    setShowMissCreditInfo: setShowMissCreditInfo
  }))));
  return /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (context) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ReturnsModalForm, {
      store: props === null || props === void 0 ? void 0 : props.store,
      show: showReplacement,
      hide: function hide() {
        return setShowReplacement(false);
      }
    }), !showOrderDetails && !showMissCreditInfo ? /*#__PURE__*/React.createElement("div", {
      className: "cb-account-card-list"
    }, /*#__PURE__*/React.createElement(Heading, {
      level: "2",
      field: {
        value: title
      },
      className: "cb-account__title"
    }), !isLoading && orders.length ? orders.map(function (item, index) {
      var Item = capitalizeObjEntries(item);
      return /*#__PURE__*/React.createElement(OrderCard, {
        key: "order-".concat(index),
        item: Item,
        viewDetailsActionCopy: "View Details",
        viewDetailsAction: function viewDetailsAction(e) {
          setReOrderSuccess(false);
          setCurrentOrder(Item);
          setShowOrderDetails(true);
        },
        orderAgainActionCopy: "Order Again",
        orderAgainAction: function orderAgainAction(e) {
          reOrderItems(Item === null || Item === void 0 ? void 0 : Item.OrderNumber);
          setOrderAgainAction(true);
        }
      });
    }) : /*#__PURE__*/React.createElement("div", null, !isLoading && /*#__PURE__*/React.createElement("p", null, "You don't have any past orders."), isLoading && /*#__PURE__*/React.createElement(Loading, {
      isLoading: true
    })), /*#__PURE__*/React.createElement("div", {
      className: "cb-account-miss-credit__link"
    }, /*#__PURE__*/React.createElement("a", {
      href: "#",
      onClick: function onClick(e) {
        e.preventDefault();
        setShowMissCreditInfo(true);
      }
    }, "Are you Missing Peg Credit?"))) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "cb-account-card__nav-container"
    }, !isGuest && !showMissCreditInfo && /*#__PURE__*/React.createElement("a", {
      href: "#",
      className: "cb-account-card__back",
      onClick: function onClick(e) {
        e.preventDefault();
        setShowOrderDetails(false);
        setClickedBack(true);
      }
    }, /*#__PURE__*/React.createElement(FaChevronLeft, null)), isGuest && !showMissCreditInfo && /*#__PURE__*/React.createElement("a", {
      href: "#",
      className: "cb-account-card__back",
      onClick: function onClick(e) {
        e.preventDefault();
        responseGuestOrder();
      }
    }, "Find Different Order"), !showMissCreditInfo && /*#__PURE__*/React.createElement("span", {
      className: "cb-account-card__nav-header"
    }, "Order Details")), !showMissCreditInfo && showOrderDetails ? /*#__PURE__*/React.createElement(CurrentOrder, {
      order: currentOrder,
      isGuest: isGuest,
      returnAction: function returnAction(item) {
        setShowReplacement(true);
        toReturn(item);
      },
      topAction: function topAction(orderId, lineId) {
        addLineFromOrder(orderId, lineId);
        setOrderAgainAction(true);
      },
      fields: fields,
      mockOrders: mockOrders
    }) : /*#__PURE__*/React.createElement(MissingCredit, {
      setShowMissCreditInfo: setShowMissCreditInfo,
      fields: (fields === null || fields === void 0 ? void 0 : fields.MissingCredit) && (fields === null || fields === void 0 ? void 0 : fields.MissingCredit.length) >= 1 ? fields.MissingCredit[0].fields : {}
    })));
  }.bind(_this));
};

var OrderCard = function OrderCard(props) {
  var item = props.item,
      _props$viewDetailsAct = props.viewDetailsAction,
      viewDetailsAction = _props$viewDetailsAct === void 0 ? function () {
    return "";
  } : _props$viewDetailsAct,
      viewDetailsActionCopy = props.viewDetailsActionCopy,
      _props$orderAgainActi = props.orderAgainAction,
      orderAgainAction = _props$orderAgainActi === void 0 ? function () {
    return "";
  } : _props$orderAgainActi,
      orderAgainActionCopy = props.orderAgainActionCopy;
  var FormatedDate = moment(item.OrderDate).format("dddd, MMMM D, YYYY");
  var title = FormatedDate;
  var mobileTitle = FormatedDate;
  var orderNumber = "$".concat(item.Price.Total, " | Order # ").concat(item.OrderNumber, " | ").concat(item.Status);
  var items = item.CartLines || item.Items || [];
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-account-card",
    onClick: function onClick(e) {
      if (typeof viewDetailsAction === "undefined") {
        return false;
      }

      return viewDetailsAction();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-account-card__header"
  }, /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: 990
  }, /*#__PURE__*/React.createElement("h3", null, mobileTitle)), /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: 991
  }, /*#__PURE__*/React.createElement("h3", null, title))), /*#__PURE__*/React.createElement("div", {
    className: "cb-account-order"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "cb-account-order__title"
  }, orderNumber)));
};

var Card = function Card(props) {
  var item = props.item,
      _props$full = props.full,
      full = _props$full === void 0 ? false : _props$full,
      _props$topAction = props.topAction,
      topAction = _props$topAction === void 0 ? function () {
    console.log("action");
  } : _props$topAction,
      _props$returnAction = props.returnAction,
      returnAction = _props$returnAction === void 0 ? function () {
    console.log("returnAction");
  } : _props$returnAction;
  var _item$Product = item.Product,
      Product = _item$Product === void 0 ? {} : _item$Product,
      ReturnDetails = item.ReturnDetails;
  var DisplayName = Product.DisplayName,
      ImageFilePath = Product.ImageFilePath,
      CatalogName = Product.CatalogName;
  var IsReturnInitiated = ReturnDetails.IsReturnInitiated,
      Reason = ReturnDetails.Reason,
      returnQty = ReturnDetails.Quantity,
      ReturnWindowExpired = ReturnDetails.ReturnWindowExpired,
      Status = ReturnDetails.Status;
  var image = {
    value: {
      src: ImageFilePath || "",
      alt: DisplayName,
      title: DisplayName
    }
  };
  var isRetail = CatalogName === CATALOGUETYPES.retail;
  return /*#__PURE__*/React.createElement(Row, {
    className: "\n    cb-account-order__item\n    ".concat(full ? "cb-account-order__item--detail" : "", "\n    ")
  }, /*#__PURE__*/React.createElement(Col, {
    className: full ? "d-flex" : ""
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-account-order__item-image"
  }, /*#__PURE__*/React.createElement(ImageLoader, {
    isEditing: false,
    media: image,
    className: "cb-card__image cb-card__image--contain"
  })), /*#__PURE__*/React.createElement("div", {
    className: "cb-account-order__item-description"
  }, /*#__PURE__*/React.createElement("p", null, item.Product.DisplayName), /*#__PURE__*/React.createElement("p", null, item.LineCost), /*#__PURE__*/React.createElement("p", {
    className: "mt-16"
  }, Boolean(item.TrackingNumber) ? "Tracking Number: ".concat(item.TrackingNumber) : null), IsReturnInitiated && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "mt-16"
  }, "Return Status: ", Status), /*#__PURE__*/React.createElement("form", {
    method: "POST",
    action: "https://row.ups.com/GuestAccess/Guest/Access",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "Company",
    value: "Q0I="
  }), /*#__PURE__*/React.createElement("input", {
    type: "submit",
    className: "cb-button-unstyled cb-button-link",
    value: "Print your shipping label here"
  }))))), full ? /*#__PURE__*/React.createElement(Col, {
    lg: "3",
    sm: "12",
    className: "cb-account-order__item-actions"
  }, isRetail && !IsReturnInitiated && /*#__PURE__*/React.createElement("button", {
    onClick: function onClick(e) {
      if (typeof returnAction === "undefined") {
        return false;
      }

      return returnAction(item);
    },
    className: "cb-button-secondary mt-16",
    style: {
      paddingRight: 0,
      paddingLeft: 0
    }
  }, "Return")) : null);
};

var CurrentOrder = function CurrentOrder(props) {
  var _order$OloStoreCompon;

  var order = props.order,
      isGuest = props.isGuest,
      _props$returnAction2 = props.returnAction,
      _returnAction = _props$returnAction2 === void 0 ? function () {
    return "";
  } : _props$returnAction2,
      _props$topAction2 = props.topAction,
      topAction = _props$topAction2 === void 0 ? function () {
    return "";
  } : _props$topAction2,
      fields = props.fields;

  console.log(props);
  var Status = order.Status,
      Price = order.Price,
      Id = order.Id;
  var FormatedDate = moment(order.OrderDate).format("dddd, MMMM D, YYYY");
  var title = "$".concat(order.Price.Total, " | Order # ").concat(order.OrderNumber, " | ").concat(order.Status);
  var items = order.CartLines || order.Items;

  var actionForLineItem = function actionForLineItem(lineId) {
    topAction(order.Id, lineId);
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "cb-account-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-account-card__header"
  }, /*#__PURE__*/React.createElement("h3", null, FormatedDate)), /*#__PURE__*/React.createElement("div", {
    className: "cb-account-order"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "cb-account-order__title"
  }, title), /*#__PURE__*/React.createElement("span", {
    className: "cb-account-order__callout"
  }, (_order$OloStoreCompon = order.OloStoreComponent) === null || _order$OloStoreCompon === void 0 ? void 0 : _order$OloStoreCompon.StoreName)), /*#__PURE__*/React.createElement("div", {
    className: "cb-account-order__container"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    className: "cb-account-order__container--info"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h4", {
    className: "cb-account-order__title"
  }, "Subtotal")), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("span", {
    className: "cb-account-order__value"
  }, "$", Price.Subtotal.toFixed(2)))), (Price === null || Price === void 0 ? void 0 : Price.TotalSavings) && (Price === null || Price === void 0 ? void 0 : Price.TotalSavings) > 0 ? /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h4", {
    className: "cb-account-order__rewards-callout"
  }, "Rewards Redeemed")), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("span", {
    className: "cb-account-order__value cb-account-order__rewards-callout"
  }, "-$", Price.TotalSavings.toFixed(2)))) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h4", {
    className: "cb-account-order__title"
  }, "Collected tax")), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("span", {
    className: "cb-account-order__value"
  }, "$", Price.TaxTotal.toFixed(2)))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h4", {
    className: "cb-account-order__title"
  }, "Tip")), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("span", {
    className: "cb-account-order__value"
  }, "$", Price.OloTip.toFixed(2)))), (Price === null || Price === void 0 ? void 0 : Price.GiftCardTotal) && (Price === null || Price === void 0 ? void 0 : Price.GiftCardTotal) > 0 ? /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h4", {
    className: "cb-account-order__title"
  }, "Gift Card:")), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
    className: ""
  }, "$", Price.GiftCardTotal))) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement(Row, {
    className: "cb-account-order__total-container"
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h4", {
    className: "cb-account-order__total"
  }, "Total")), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("span", {
    className: "cb-account-order__value cb-account-order__total"
  }, "$", Price.Total.toFixed(2)))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(PegModule, {
    store: props === null || props === void 0 ? void 0 : props.store,
    authenticationState: AuthenticationState.Authenticated,
    orderId: Id,
    fields: (fields === null || fields === void 0 ? void 0 : fields.PegModule) && (fields === null || fields === void 0 ? void 0 : fields.PegModule.length) >= 1 ? fields.PegModule[0].fields : {}
  })))), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Container, null, items.map(function (item, index) {
    var Item = capitalizeObjEntries(item);
    return /*#__PURE__*/React.createElement(Row, {
      key: "cart-item-".concat(index),
      className: "cb-account-order__divider"
    }, /*#__PURE__*/React.createElement(Col, {
      key: "cart-item-".concat(index)
    }, /*#__PURE__*/React.createElement(Card, {
      item: Item,
      full: true,
      topAction: function topAction(e) {
        actionForLineItem(Item.Id);
      },
      returnAction: function returnAction(e) {
        e.orderNumber = order.OrderNumber;

        _returnAction(e);
      }
    })));
  })))))));
};

var MissingCredit = function MissingCredit(props) {
  var fields = props.fields,
      _props$setShowMissCre = props.setShowMissCreditInfo,
      setShowMissCreditInfo = _props$setShowMissCre === void 0 ? function () {
    return "";
  } : _props$setShowMissCre;
  console.log("fields", fields);
  var logo = fields.logo,
      onPressAction = fields.onPressAction,
      contactButtonLink = fields.contactButtonLink,
      header = fields.header,
      description = fields.description,
      contactButtonLabel = fields.contactButtonLabel,
      legalInfoCopy = fields.legalInfoCopy;

  var redirectToLink = function redirectToLink(e) {
    e.preventDefault();
    window.location.href = contactButtonLink.value;
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "cb-account-miss-credit"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-account-miss-credit__header"
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    className: "cb-account-miss-credit__back",
    onClick: function onClick(e) {
      e.preventDefault();
      setShowMissCreditInfo(false);
    }
  }, /*#__PURE__*/React.createElement(FaChevronLeft, null)), /*#__PURE__*/React.createElement("div", {
    className: "cb-account-miss-credit__logo"
  }, /*#__PURE__*/React.createElement(Image, {
    field: logo
  }))), /*#__PURE__*/React.createElement("div", {
    className: "cb-account-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-account-card__header"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    field: {
      value: header ? header.value : ""
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "cb-account-card__body"
  }, /*#__PURE__*/React.createElement(RichText, {
    field: description,
    tag: "p"
  }), contactButtonLink && contactButtonLink.value !== "" && /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-primary",
    onClick: redirectToLink
  }, contactButtonLabel.value))), /*#__PURE__*/React.createElement("div", {
    className: "cb-account-miss-credit__terms"
  }, /*#__PURE__*/React.createElement(RichText, {
    field: legalInfoCopy,
    tag: "p"
  })));
};

var mapStateToProps = function mapStateToProps(state) {
  var _state$account, _state$account2, _state$account3, _state$account4, _state$account5;

  return {
    orders: (_state$account = state.account) === null || _state$account === void 0 ? void 0 : _state$account.orders,
    isLoading: (_state$account2 = state.account) === null || _state$account2 === void 0 ? void 0 : _state$account2.isLoading,
    showReplacement: (_state$account3 = state.account) === null || _state$account3 === void 0 ? void 0 : _state$account3.showReplacement,
    isError: state.error.isError,
    err: state.error.err,
    token: (_state$account4 = state.account) === null || _state$account4 === void 0 ? void 0 : _state$account4.aadResponse,
    reOrderSuccess: (_state$account5 = state.account) === null || _state$account5 === void 0 ? void 0 : _state$account5.reOrderSuccess
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getAccountOrders: function getAccountOrders() {
      return dispatch(accountOperations.getAccountOrders());
    },
    responseGuestOrder: function responseGuestOrder() {
      return dispatch(accountOperations.responseGuestOrder({
        orders: []
      }));
    },
    toReturn: function toReturn(item) {
      return dispatch(accountOperations.toReturn(item));
    },
    setShowReplacement: function setShowReplacement(el) {
      return dispatch(accountOperations.setShowReplacement(el));
    },
    reOrderItems: function reOrderItems(orderId) {
      return dispatch(accountOperations.reOrderItems(orderId));
    },
    setReOrderSuccess: function setReOrderSuccess(success) {
      return dispatch(accountOperations.responseReOrder(success));
    },
    addLineFromOrder: function addLineFromOrder(orderId, lineId) {
      return dispatch(accountOperations.addLineFromOrder(orderId, lineId));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountOrders);